import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'
import storeInit from 'initializations/pages/CharterPage'

export class Main extends AbstractView {
  constructor(domElementId) {
    return super(domElementId);
  }

  init() {
    storeInit.init("cargoForm")

    const CargoForm = () => import(/* webpackChunkName: "cargo-form" */ 'containers/Pages/CharterCargo/CargoForm')

    new Vue({
      el: "#" + this.elemId,
      store,
      render: h => h(CargoForm)
    })
  }
}
